export const getDocumentSubtype = (document = {}) => {
  const { document_type: documentType } = document;

  if (documentType === 'judgment') {
    return document.judgment_type;
  }
};
